import { render, staticRenderFns } from "./UserDetailBase.vue?vue&type=template&id=6eafa38e&scoped=true"
import script from "./UserDetailBase.vue?vue&type=script&lang=js"
export * from "./UserDetailBase.vue?vue&type=script&lang=js"
import style0 from "./UserDetailBase.vue?vue&type=style&index=0&id=6eafa38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eafa38e",
  null
  
)

export default component.exports